import { Text, View } from '@react-pdf/renderer';
import { productsDataStyles } from './productsDataStyles';
import { useFormatNumber } from '../../../../hooks/useFormatNumber';
const { productsData } = productsDataStyles();

export const ProductsData = ({ data, showTranslatedText }: any) => {

       const { setFormatNumber } = useFormatNumber();

    return (
        <>
            <View style={productsData.titleRow}>
                <View style={{ flex: 2, justifyContent: 'center', alignItems:'center' }}>
                    <Text style={{ fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesPreorderPdf.itemsTable.concept")}</Text>
                </View>
                <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems:'center' }}>
                    <Text style={{ fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesPreorderPdf.itemsTable.quantity")}</Text>
                </View>
                <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems:'center' }}>
                    <Text style={{ fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesPreorderPdf.itemsTable.unit")}</Text>
                </View>
                <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems:'center' }}>
                    <Text style={{ fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesPreorderPdf.itemsTable.price")}</Text>
                </View>
                <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems:'center' }}>
                    <Text style={{ fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesPreorderPdf.itemsTable.tax")}</Text>
                </View>
                <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems:'center' }}>
                    <Text style={{ fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesPreorderPdf.itemsTable.retention")}</Text>
                </View>
                <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems:'center', borderRightWidth: 1  }}>
                    <Text style={{ fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesPreorderPdf.itemsTable.discount")}(%)</Text>
                </View>
            </View>
            {data.dataSalesPreordersDetails.length > 0 &&
                data.dataSalesPreordersDetails.map((item: any, index: number) =>
                    <View key={index} wrap={false}  >
                        <View style={productsData.row} >
                            <View style={{ flex: 2, borderLeftWidth: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ fontSize: 6 }}>{item.item_description || ' '}</Text>
                            </View>
                            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ fontSize: 6 }}>{item.quantity || ' '}</Text>
                            </View>
                            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ fontSize: 6 }}>{item.unit_code || ' '}</Text>
                            </View>
                            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ fontSize: 6 }}>{setFormatNumber({ value: item.price_by_unit || 0 }) || ' '}</Text>
                            </View>
                            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ fontSize: 6 }}>{item.tax_name || ' '} {item.tax_percent || ' '}</Text>
                            </View>
                            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ fontSize: 6 }}>{item.retention_name || ' '} {item.retention_percent || ' '}</Text>
                            </View>
                            <View style={{ flex: 1, borderLeftWidth: 1, borderRightWidth: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ fontSize: 6 }}>{item.discount || ' '}</Text>
                            </View>
                        </View>
                    </View>
                )
            }
        </>
    );
};



